import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { useToast } from '@/hooks/use-toast';
import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';
import { LOCAL__user_auth_logout } from '@/state/user/auth/LOCAL__user_auth_logout';
import { LOCAL__user_auth_set_open_page_after_login } from '@/state/user/auth/LOCAL__user_auth_set_open_page_after_login';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';

export function WATCHER__user_auth_failed() {
  const dispatch = use_dispatch();
  const { toast } = useToast();
  const navigate = use_navigate_ud();

  use_effect(() => {
    service_local_events.on(ENUM__local_event.USER_AUTH_FAILED, on_user_auth_failed);

    return () => service_local_events.off(ENUM__local_event.USER_AUTH_FAILED, on_user_auth_failed);
  }, []);

  async function on_user_auth_failed() {
    CONSTANTS__environment_client.VITE_AUTH_AUTOLOGIN_BOOLEAN = false;

    dispatch(LOCAL__user_auth_logout());
    dispatch(LOCAL__user_auth_set_open_page_after_login(''));
    dispatch(LOCAL__workspace_set_is_all_data_loaded(true));

    toast({ title: 'User authentication failed' });

    navigate(ENUM__page_type.AUTH);
  }

  return null;
}
